module.exports = __webpack_public_path__ + "img/tse.a2be4f9.jpg";